<template>
    <div style="display: flex; flex-direction: column; position: relative; background-color: black;">
        <div @click="() => { $GlobalStore.closeLastModal() }" style="display:grid; position: absolute; width: 20px; padding: 20px;"><img :src="require('@/assets/img/white_x_btn_new.png')" style="width:20px;"></div>
        <div style="flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <div v-if="isYoutube" class="video-container">
                <iframe :id="'youtubePlayer_' + randomNum" :src="getYouTubeEmbedUrl(urlPath) + '&autoplay=1'" frameborder="0" sandbox="allow-scripts allow-same-origin allow-popups" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen style="width:100%;">
                </iframe>
            </div>
            <div v-else>
                <video ref="videoPlayer" :poster="$resourcePath + thumbnail_path" controls width="100%" height="220" style="border-radius: 12px; position: relative;">
                    <source style="width: 100%; height: 100%;" :src="urlPath" type="video/mp4">
                </video>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {TRIGGER_TYPE} from "../../Constants";

export default {
    name: 'VideoViewer',
    props: {
        urlPath: {
            type: String,
            default: ''
        },
        isYoutube: {
            type: Boolean,
            default: false
        },
        thumbnail_path: {
            type: String,
            default: ''
        },
        refer_type : {
            type : String,
            default : ''
        },
        refer_info : {
            type : Object,
            default : () => {}
        }
    },
    created() {
        if(this.refer_type === 'training' && this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '0'){
            let watched_training_videos = {};
            const TODAY_WATCHED_TRAINING_VIDEOS = 'TODAY_WATCHED_TRAINING_VIDEOS';
            const today = moment().format('YYYY-MM-DD');
            if(this.$hasOwnProperty(localStorage, TODAY_WATCHED_TRAINING_VIDEOS)){
                watched_training_videos = JSON.parse(localStorage.getItem(TODAY_WATCHED_TRAINING_VIDEOS));
                if(watched_training_videos.today !== today){
                    watched_training_videos = {today : today, soccerhow_idxes : {}};
                }
            }else {
                watched_training_videos = {today : today, soccerhow_idxes : {}};
            }

            if(!this.$hasOwnProperty(watched_training_videos.soccerhow_idxes, '' + this.refer_info.idx)){
                watched_training_videos.soccerhow_idxes['' + this.refer_info.idx] = 1;
            }

            if(Object.keys(watched_training_videos.soccerhow_idxes).length >= 3){
                const parameters = {};
                parameters.trigger_type = TRIGGER_TYPE.LURKING_ESCAPE;
                this.$Axios.post('/api/member/trigger/save', parameters)
            }

            localStorage.setItem(TODAY_WATCHED_TRAINING_VIDEOS, JSON.stringify(watched_training_videos))
        }

        if(this.$GlobalStore.loginInfo().is_coach === '1'){
            const parameters = {};
            parameters.trigger_type = TRIGGER_TYPE.GROUND_TRAINING_VIDEO_AFTER;
            parameters.refer_idx = this.refer_info.idx;
            this.$Axios.post('/api/member/trigger/save', parameters)
        }

        if (this.isYoutube) {
            const random = Math.random()
            this.randomNum = random

            // this.$nextTick(() => {
            //     /*eslint-disable no-undef */
            //     new YT.Player(`youtubePlayer_${this.randomNum}`, {
            //         events: {
            //             "onReady": (event) => {
            //                 event.target.mute();
            //                 event.target.playVideo();
            //             }
            //         }
            //     });
            // })
        } else {
            this.$nextTick(() => {
                const video = this.$refs.videoPlayer;
                if (video) {
                    video.play().catch(error => {
                        console.error("자동 재생 실패:", error);
                    });
                }
            });
        }
    },
    data() {
        return {
            randomNum: null
        }
    },
    methods: {
        getYouTubeEmbedUrl(url) {
            let replace_url = ''
            if (url.includes('https://youtu.be/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://youtu.be/', '')}`;
            } else if (url.includes('https://www.youtube.com/shorts/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://www.youtube.com/shorts/', '')}`;
            } else if (url.includes('https://youtube.com/shorts/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://youtube.com/shorts/', '')}`;
            } else if (url.includes('https://www.youtube.com/watch?v=')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://www.youtube.com/watch?v=', '')}`;
                replace_url = replace_url.replace('&', '?');
            } else if (url.includes('https://youtube.com/watch?v=')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://youtube.com/watch?v=', '')}`;
                replace_url = replace_url.replace('&', '?');
            } else if (url.includes('https://www.youtube.com/live/')) {
                replace_url = `https://www.youtube.com/embed/${url.replace('https://www.youtube.com/live/', '')}`;
            }

            replace_url += replace_url.includes('?') ? '&enablejsapi=1&mute=1' : '?enablejsapi=1&mute=1';

            return replace_url;
        }
    },
}
</script>

<style scoped>
.video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 0px;
    height: 0;
    overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>